import type { IGetUploadFileParams, IUploadFileParams } from 'core/model/interfaces/downloads-uploads';
import { uploadsData } from './uploads.data';
import { mapDtoToGetUploadFile, mapDtoToUploadList, toUploadFileParams } from './uploads.mappers';

export const uploadsService = {
  getUploadList: async () => {
    const response = await uploadsData.getUploadList();

    return mapDtoToUploadList(response);
  },
  getUploadByFileType: async (params: IGetUploadFileParams) => {
    const response = await uploadsData.getUploadByFileType(params);

    return mapDtoToGetUploadFile(response);
  },
  uploadFile: async (params: IUploadFileParams) => {
    const formData = toUploadFileParams(params);

    const response = await uploadsData.uploadFile(params, formData);

    return response;
  },
};
